import gql from 'graphql-tag'
import { PRODUCT_REFERENCE_FRAGMENT, PRODUCT_FRAGMENT } from './fragments.graphql'

export const GET_PRODUCT_FILTER_LIST_BY_ACTIVITY_ID = gql`
  ${PRODUCT_REFERENCE_FRAGMENT}
  ${PRODUCT_FRAGMENT}

  query GetProductFilterListByActivityId(
    $activityId: Int!
    $facets: [FacetParameterInput!]
    $sortBy: SortBy!
    $page: Int!
    $pageSize: Int!
  ) {
    activity(activityId: $activityId) {
      productFilterList(facets: $facets, sortBy: $sortBy, page: $page, pageSize: $pageSize) {
        productReferences {
          ...ProductReference
        }
        facets {
          name
          type
          displayName
          displayEnglishName
          facetOpened
          nameInUrl
          isTranslated
          unitText
          values {
            displayName
            name
            hits
            min
            max
          }
          id
          ticket
          displayOrder
          facetType
        }
        hits
        pagination {
          pageSize
          totalPages
          page
          totalHitsUntilEnd
        }
      }
      banners {
        displayMode
        imageUrl
        text
        relatedProductErpIdentifiers
        relatedProducts {
          ...Product
        }
      }
    }
  }
`
